import { render } from "./App.vue?vue&type=template&id=ea06b7ac"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ea06b7ac&lang=scss"
import "./App.vue?vue&type=style&index=1&id=ea06b7ac&lang=css"

import exportComponent from "/Users/vee/Desktop/git/web/bitcoooPcWebsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__